import { useRef, useEffect, useCallback } from 'react';

import { standardBlueprintVersion } from '../../../blueprint';
import { useTreatment } from '../../../hooks/experiments/useGetTreatment';
import { FeatureName } from '../../../utils';

import type { BlueprintVersion } from '../../../blueprint';

export function useGetBlueprintVersion(): () => Promise<BlueprintVersion> {
  const { isReady, treatment } = useTreatment(
    FeatureName.CVR_CONSOLIDATE_ME_PAGES
  );

  const blueprintVersionPromiseRef = useRef(
    Promise.withResolvers<BlueprintVersion>()
  );

  useEffect(() => {
    if (isReady) {
      blueprintVersionPromiseRef.current.resolve(standardBlueprintVersion);
    }
  }, [isReady, treatment]);

  return useCallback(() => blueprintVersionPromiseRef.current.promise, []);
}
